import {
  IFetchProjectVersionSettingsSuccessResponseBody,
  ISubmitProjectVersionUpdatePayload,
  ProjectVersionSettingsActionTypes,
  IFetchProjectVersionSettingsPayload,
  IAddElementsForProjectVersionsPayload,
  IRemoveFromElementsForProjectVersionsPayload,
  ISetValuesAfterUploadPayload,
  IAddProjectIdPendingCleanupPayload,
  IRemoveFromSubmittingUrlsPayload,
  IUpdateDownloadingElementsPayload,
  IUpdateDownloadingElementsSuccessResponseBody,
  IFetchTranslationLanguagesPayload,
  IFetchTranslationLanguagesSuccessResponseBody,
} from './types'

export const submitProjectVersionUpdate = (payload: ISubmitProjectVersionUpdatePayload) => ({
  type: ProjectVersionSettingsActionTypes.SUBMIT_PROJECT_VERSION_UPDATE,
  payload,
})

export const submitProjectVersionUpdateSuccess = () => ({
  type: ProjectVersionSettingsActionTypes.SUBMIT_PROJECT_VERSION_UPDATE_SUCCESS
})

export const submitProjectVersionUpdateFailure = () => ({
  type: ProjectVersionSettingsActionTypes.SUBMIT_PROJECT_VERSION_UPDATE_FAILURE,
})

export const beginProjectSubmission = () => ({
  type: ProjectVersionSettingsActionTypes.BEGIN_PROJECT_SUBMISSION,
})

export const completeProjectSubmission = () => ({
  type: ProjectVersionSettingsActionTypes.COMPLETE_PROJECT_SUBMISSION,
})

export const failProjectSubmission = () => ({
  type: ProjectVersionSettingsActionTypes.FAIL_PROJECT_SUBMISSION,
})

export const fetchProjectVersionSettings = (payload: IFetchProjectVersionSettingsPayload) => ({
  type: ProjectVersionSettingsActionTypes.FETCH_PROJECT_VERSION_SETTINGS,
  payload,
})

export const fetchProjectVersionSettingsSuccess = (payload: IFetchProjectVersionSettingsSuccessResponseBody) => ({
  type: ProjectVersionSettingsActionTypes.FETCH_PROJECT_VERSION_SETTINGS_SUCCESS,
  payload,
})

export const projectVersionSettingsFailure = () => ({
  type: ProjectVersionSettingsActionTypes.PROJECT_VERSION_SETTINGS_FAILURE,
})

export const resetProjectVersionSettings = () => ({
  type: ProjectVersionSettingsActionTypes.RESET_PROJECT_VERSION_SETTINGS,
})

export const addElementsForProjectVersions = (payload: IAddElementsForProjectVersionsPayload) => ({
  type: ProjectVersionSettingsActionTypes.ADD_ELEMENTS_FOR_PROJECT_VERSIONS,
  payload,
})

export const removeFromElementsForProjectVersions = (payload: IRemoveFromElementsForProjectVersionsPayload) => ({
  type: ProjectVersionSettingsActionTypes.REMOVE_FROM_ELEMENTS_FOR_PROJECT_VERSIONS,
  payload,
})

export const setValuesAfterUpload = (payload: ISetValuesAfterUploadPayload) => ({
  type: ProjectVersionSettingsActionTypes.SET_VALUES_AFTER_UPLOAD,
  payload,
})

export const addProjectIdPendingCleanup = (payload: IAddProjectIdPendingCleanupPayload) => ({
  type: ProjectVersionSettingsActionTypes.ADD_PROJECT_ID_PENDING_CLEANUP,
  payload,
})

export const releaseProjectCleanupOwnership = () => ({
  type: ProjectVersionSettingsActionTypes.RELEASE_PROJECT_CLEANUP_OWNERSHIP,
})

export const setSizeLimitsAlertAtSubmitUrl = () => ({
  type: ProjectVersionSettingsActionTypes.SET_SIZE_LIMITS_ALERT_AT_SUBMIT_URL,
})

export const resetSizeLimitsAlertAtSubmitUrl = () => ({
  type: ProjectVersionSettingsActionTypes.RESET_SIZE_LIMITS_ALERT_AT_SUBMIT_URL,
})

export const removeFromSubmittingUrls = (payload: IRemoveFromSubmittingUrlsPayload) => ({
  type: ProjectVersionSettingsActionTypes.REMOVE_FROM_SUBMITTING_URLS,
  payload,
})

export const resetSubmittingUrls = () => ({
  type: ProjectVersionSettingsActionTypes.RESET_SUBMITTING_URLS
})

export const updateDownloadingElements = (payload: IUpdateDownloadingElementsPayload) => ({
  type: ProjectVersionSettingsActionTypes.UPDATE_DOWNLOADING_ELEMENTS,
  payload,
})

export const updateDownloadingElementsSuccess = (payload: IUpdateDownloadingElementsSuccessResponseBody) => ({
  type: ProjectVersionSettingsActionTypes.UPDATE_DOWNLOADING_ELEMENTS_SUCCESS,
  payload,
})

export const updateDownloadingElementsFailure = () => ({
  type: ProjectVersionSettingsActionTypes.UPDATE_DOWNLOADING_ELEMENTS_FAILURE,
})

export const fetchTranslationLanguages = (payload: IFetchTranslationLanguagesPayload) => ({
  type: ProjectVersionSettingsActionTypes.FETCH_TRANSLATION_LANGUAGES,
  payload,
})

export const fetchTranslationLanguagesSuccess = (payload: IFetchTranslationLanguagesSuccessResponseBody) => ({
  type: ProjectVersionSettingsActionTypes.FETCH_TRANSLATION_LANGUAGES_SUCCESS,
  payload,
})

export const fetchTranslationLanguagesFailure = () => ({
  type: ProjectVersionSettingsActionTypes.FETCH_TRANSLATION_LANGUAGES_FAILURE,
})

export const resetTranslationLanguages = () => ({
  type: ProjectVersionSettingsActionTypes.RESET_TRANSLATION_LANGUAGES,
})
